import React, { useEffect, useState } from "react";
import styled from "styled-components";

const EditableTextArea = ({ Description, handleEdit, id }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [content, setContent] = useState(Description);

  useEffect(() => {
    setContent(Description);
  }, [Description]);

  const handleClick = () => {
    setIsEditing(true);
  };

  const handleBlur = () => {
    setIsEditing(false);
    handleEdit({
      variables: {
        id: id,
        userInput: { Description: content },
      },
    });
  };

  const handleChange = (e) => {
    setContent(e.target.value);
  };

  return (
    <Container>
      <Header>Description</Header>
      {isEditing ? (
        <Textarea value={content} onChange={handleChange} onBlur={handleBlur} autoFocus />
      ) : (
        <EditableContent onClick={handleClick}>{content ? content : "Add  Detailed Description..."}</EditableContent>
      )}
      {/* {isEditing && (
        <EditButtons>
          <IconButton onClick={handleBlur}>
            <FaCheck size={15} />
          </IconButton>
          <IconButton onClick={() => setIsEditing(false)}>
            <FaTimes size={15} />
          </IconButton>
        </EditButtons>
      )} */}
    </Container>
  );
};

export default EditableTextArea;

const Container = styled.div`
  /* font-size: 22px; */
  /* font-weight: 500; */
  color: #172b4d;
  padding-bottom: 5px;
`;

const EditableContent = styled.div`
  border: ${(props) => (!props.isEditing ? "1px solid transparent" : "none")};
  padding: 5px;
  white-space: pre-wrap; /* Preserve whitespace and line breaks */
  cursor: pointer;
  font-size: 14px;
`;

const Textarea = styled.textarea`
  width: 100%;
  height: auto; // Adjust based on your content needs
  padding: 5px;
  border: 1px solid #388bff; // Default border color
  border-radius: 3px;
  resize: vertical; // Optional: prevent resizing

  &:focus {
    outline: none; // Removes the default focus outline
    border-color: #388bff; // Keeps the border blue when focused
    box-shadow: 0 0 3px #388bff; // Adds a subtle glow effect
  }
`;



// const IconButton = styled.button`
//   border: none;
//   color: #42526e;
//   background: #ffffff;
//   border-radius: 3px;
//   height: 30px;
//   width: 30px;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   cursor: pointer;
//   margin-left: 4px; // Space between buttons
//   box-shadow: 0 2px 0 rgba(9, 30, 66, 0.25);

//   &:hover {
//     background-color: #ebecf0;
//   }

//   &:active {
//     background-color: #dfe1e6;
//   }
// `;

const Header = styled.div`
  font-size: 14px;
  color: #42526e;
  font-weight: 500;
`;
